export const PRODUCTION_ENV = "production";
export const DEVELOPMENT_ENV = "dev";
